/**
 * Whether the app is served on a "selective AI" (Da1TimeTable) host. Kept free of app imports
 * so low-level modules (i18n provider, helpers) can use it without pulling in the redux store
 * the way `common/HelperFunctions` does. `isSelectiveAiDomains` in HelperFunctions delegates here.
 */
export const isSelectiveAiDomainHost = (hostname: string = window.location.hostname) =>
  // Local-dev toggle: comment this line out to see the non-Da1TimeTable wording on localhost.
  hostname.includes('localhost') ||
  hostname.includes('da1timetable.ai') ||
  hostname.includes('da1timetable.info') ||
  hostname.includes('ilmversity.ai')
